import {IShopsState} from 'modules/shops/types';
import {createContext} from 'react';

export const ShopListPageContext = createContext<IShopsState>({
    shopsData: {},
} as IShopsState);
